const lcd3Width = 170.801
const lcd3Height = 102.721

const lcd4Width = 235
const lcd4Height = 102.721

const lcd5Width = 293
const lcd5Height = 102.721

const lcd6Width = 363.67
const lcd6Height = 113.387

const lcd7Width = 431.85
const lcd7Height = 113.387

const lcd8Width = 491.85
const lcd8Height = 113.387


const lcd9Width = 559.85
const lcd9Height = 113.387


const lcd10Width = 627.85
const lcd10Height = 113.387
export default class Part {

    static render(width, mods) {


        const lcdWidth = {};
        lcdWidth[1] = 55;
        lcdWidth[2] = 113;
        lcdWidth[3] = lcd3Width;
        lcdWidth[4] = lcd4Width;
        lcdWidth[5] = lcd5Width;
        lcdWidth[6] = lcd6Width;
        lcdWidth[7] = lcd7Width;
        lcdWidth[8] = lcd8Width;
        lcdWidth[9] = lcd9Width;
        lcdWidth[10] = lcd10Width;

        const lcdHeight = {};
        lcdHeight[1] = 71.052162;
        lcdHeight[2] = 88.33477;
        lcdHeight[3] = lcd3Height;
        lcdHeight[4] = lcd4Height;
        lcdHeight[5] = lcd5Height;
        lcdHeight[6] = lcd6Height;
        lcdHeight[7] = lcd7Height;
        lcdHeight[8] = lcd8Height;
        lcdHeight[9] = lcd9Height;
        lcdHeight[10] = lcd10Height;

        const WIDTH = width * SIZE.pxInMm;
        const HEIGHT = SIZE.baseHeight // TODO  
        let x = (WIDTH - lcdWidth[mods]) / 2
        let y = (HEIGHT - lcdHeight[mods]) / 2

        return `<image href="${PARTS['lcd_' + mods]}" x="${x}" y="${y}" />`
    }
}
